import { Locale, StoreKey } from "src/lib/Intl";
import { StoreConfig, storeConfigs } from "src/utils/storeConfig";

export type AppConfig = {
  locale: Locale;
  storeKey: StoreKey;
  constructorIndexKey: string;
  eppoApiKey: string;
  constructorBeaconBundle: string;
  googleClientId: string;
};

const DEFAULT_CONFIG: AppConfig = {
  locale: "en",
  storeKey: "OT-COM",
  constructorIndexKey: "",
  eppoApiKey: "",
  constructorBeaconBundle: "",
  googleClientId: "",
};

function readServerConfig(): AppConfig {
  return {
    locale: (process.env.LOCALE as Locale) || DEFAULT_CONFIG.locale,
    storeKey: (process.env.STORE_KEY as StoreKey) || DEFAULT_CONFIG.storeKey,
    constructorIndexKey:
      process.env.CONSTRUCTOR_INDEX_KEY || DEFAULT_CONFIG.constructorIndexKey,
    eppoApiKey: process.env.EPPO_API_KEY || DEFAULT_CONFIG.eppoApiKey,
    constructorBeaconBundle:
      process.env.CONSTRUCTOR_BEACON_BUNDLE ||
      DEFAULT_CONFIG.constructorBeaconBundle,
    googleClientId:
      process.env.GOOGLE_CLIENT_ID || DEFAULT_CONFIG.googleClientId,
  };
}

type NextDataWindow = {
  __NEXT_DATA__?: {
    props?: {
      pageProps?: {
        appConfig?: Partial<AppConfig>;
      };
    };
  };
};

function readClientConfig(): AppConfig {
  const appConfig = (window as unknown as NextDataWindow).__NEXT_DATA__?.props
    ?.pageProps?.appConfig;

  return {
    locale: (appConfig?.locale as Locale) || DEFAULT_CONFIG.locale,
    storeKey: (appConfig?.storeKey as StoreKey) || DEFAULT_CONFIG.storeKey,
    constructorIndexKey:
      appConfig?.constructorIndexKey || DEFAULT_CONFIG.constructorIndexKey,
    eppoApiKey: appConfig?.eppoApiKey || DEFAULT_CONFIG.eppoApiKey,
    constructorBeaconBundle:
      appConfig?.constructorBeaconBundle ||
      DEFAULT_CONFIG.constructorBeaconBundle,
    googleClientId: appConfig?.googleClientId || DEFAULT_CONFIG.googleClientId,
  };
}

let config: AppConfig =
  typeof window === "undefined" ? readServerConfig() : readClientConfig();

export function getConfig(): AppConfig {
  return config;
}

export function hydrateConfig(next: Partial<AppConfig>): void {
  config = { ...config, ...next };
}

export function getLocale(): Locale {
  return config.locale;
}

export function getStoreKey(): StoreKey {
  return config.storeKey;
}

export function getStoreConfig(): StoreConfig {
  return storeConfigs[config.storeKey];
}

export function getConstructorIndexKey(): string {
  return config.constructorIndexKey;
}

export function getEppoApiKey(): string {
  return config.eppoApiKey;
}

export function getConstructorBeaconBundle(): string {
  return config.constructorBeaconBundle;
}

export function getGoogleClientId(): string {
  return config.googleClientId;
}

export const locale: Locale = config.locale;

export const storeKey: StoreKey = config.storeKey;

export const storeConfig: StoreConfig = storeConfigs[config.storeKey];

export const constructorIndexKey: string = config.constructorIndexKey;

export const eppoApiKey: string = config.eppoApiKey;

export const constructorBeaconBundle: string = config.constructorBeaconBundle;

export const googleClientId: string = config.googleClientId;

export const adyenMerchantId: string =
  process.env.ADYEN_GATEWAY_MERCHANT_ID || "";

export const collectionEmail: string =
  process.env.NEXT_PUBLIC_COLLECTION_EMAIL || "";
